/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface FeedbackWorkflowTransitionData { 
    transition: FeedbackWorkflowTransitionData.TransitionEnum;
}
export namespace FeedbackWorkflowTransitionData {
    export type TransitionEnum = 'accept' | 'deliver' | 'fail' | 'reaccept' | 'receive' | 'refuse' | 'success' | 'dispatch';
    export const TransitionEnum = {
        Accept: 'accept' as TransitionEnum,
        Deliver: 'deliver' as TransitionEnum,
        Fail: 'fail' as TransitionEnum,
        Reaccept: 'reaccept' as TransitionEnum,
        Receive: 'receive' as TransitionEnum,
        Refuse: 'refuse' as TransitionEnum,
        Success: 'success' as TransitionEnum,
        Dispatch: 'dispatch' as TransitionEnum
    };
}
